import React from 'react';
import { Button } from 'reactstrap';

const GeriButonu = ({ onClick, text = "Geri" }) => {
    return (
        <div style={{ marginBottom: '15px' }}>
            <Button
                color="link"
                style={{
                    padding: '3px 10px',
                    color: 'white',
                    textDecoration: 'none',
                    fontSize: '14px',
                    backgroundColor: 'rgb(74 140 211)',
                }}
                onClick={onClick}
            >
                <i className="fa fa-arrow-left" style={{ marginRight: '5px' }}></i>
                {text}
            </Button>
        </div>
    );
};

export default GeriButonu; 